// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input,
    InputLabel,
    Select, TextField
} from "@mui/material";

// App Imports
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {changeViewership} from "./viewershipSlice";
import {addViewership, editViewership} from "./ViewershipClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import {getAllPlatforms} from "../Platform/PlatformClient";
import Stack from "@mui/material/Stack";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import dayjs from "dayjs";


// Main Function
export default function ViewershipDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorViewershipId = useSelector((state) => state.viewershipSlc.value.id);
    const selectorViewershipDrawerState = useSelector((state) => state.viewershipSlc.value.viewershipDrawerState);
    const selectorViewershipDrawerMode = useSelector((state) => state.viewershipSlc.value.viewershipDrawerMode);
    const drawerModeRef = React.useRef(selectorViewershipDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register,control, reset, handleSubmit} = useForm();


    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Viewership data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorViewershipDrawerMode==="Add"){
            addViewership(data)
                .then(() => {
                    console.log("Viewership added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeViewership({
                    id: null, externalId: null, productId: null, platformId: null,
                    viewDate: null, views: null, viewedMinutes: null, rating: null, source: null,
                    status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    platformCode: null, platformName: null,
                    service: null, platformTerritory: null, usageMarket: null, platformOwner: null,
                    propertyName: null, initialMarket: null, genre: null, productionType: null,
                    viewershipGridRefresh: true, viewershipDrawerState: false, viewershipDrawerMode: null
                }))
            })}
        if(selectorViewershipDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addViewership(data)
                .then(() => {
                    console.log("Viewership cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));

            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeViewership({id: null, externalId: null, productId: null, platformId: null,
                    viewDate: null, views: null, viewedMinutes: null, rating: null, source: null,
                    status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    platformCode: null, platformName: null,
                    service: null, platformTerritory: null, usageMarket: null, platformOwner: null,
                    propertyName: null, initialMarket: null, genre: null, productionType: null,
                    viewershipGridRefresh: true, viewershipDrawerState: false, viewershipDrawerMode: null}))
            })}
        if(selectorViewershipDrawerMode==="Edit"){
            console.log("This is the Viewership Id I am going to edit")
            console.log(selectorViewershipId)
            editViewership(selectorViewershipId, data)
                .then(() => {
                    console.log("Viewership edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeViewership({
                    viewershipGridRefresh: true, viewershipDrawerState: false, viewershipDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeViewershipDrawer() {
        // setShowContractDataPointDrawer(false);
        dispatchData(changeViewership({viewershipDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);


    const fetchPlatformsForDropdown = () =>
        getAllPlatforms()

            .then(data => {
                console.log("Platforms List")
                console.log(data);
                setPlatforms(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );

            })
    useEffect(() => {
        console.log("This is for the platforms dropdown...");
        fetchPlatformsForDropdown();
    }, []);


// *********************** END DROPDOWNS **************************

    const viewership = useSelector((state) => state.viewershipSlc.value);

    useEffect(() => {

        reset({
            ...viewership,
            viewDate: viewership.viewDate
                ? dayjs(viewership.viewDate)
                : null,

        });


    }, [viewership, reset]);
    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [licenses, setLicenses] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);

    // ****************** BEGIN FORM ****************************

    function viewershipForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeViewershipDrawer()}>Viewership Form</h2>
                    <h4>{selectorViewershipDrawerMode} Mode</h4>
                    <br/>

                    <Input
                        style={{visibility: "hidden"}}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.viewershipSlc.value.id))}
                    />
                    <br/>
                    <FormControl variant="standard" sx={{minWidth: 300}}>
                        <InputLabel htmlFor="productId">Product</InputLabel>
                        <Select

                            {...register('productId', {required: true})}
                            labelId="productId"
                            id="productId"
                            label="productId"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.propertyId)}
                            sx={{width: 600}}
                        >
                            {products.map((ProductItem) =>
                                <MenuItem value={ProductItem.id}>{ProductItem.id}: {ProductItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('externalId', {required: true})}
                            id="externalId" name="externalId" label="External ID" aria-describedby="externalId_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.externalId)}
                            sx={{width: 200}}/>
                        <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                            <InputLabel htmlFor="platformId">Platform</InputLabel>
                            <Select

                                {...register('platformId', {required: true})}
                                labelId="platformId"
                                id="platformId"
                                label="platformId"
                                // variant: "outlined"
                                defaultValue={useSelector((state) => state.viewershipSlc.value.platformId)}
                                sx={{width: 300}}
                            >
                                {platforms.map((PlatformItem) =>
                                    <MenuItem value={PlatformItem.id}>{PlatformItem.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('viewDate', {required: true})}*/}
                        {/*    id="viewDate" name="viewDate" label="View Date" aria-describedby="viewDate_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.viewershipSlc.value.viewDate)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="viewDate"
                            label="View Date"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        <TextField
                            {...register('views', {required: false})}
                            id="views" name="views" label="Views" aria-describedby="views_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.views)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('viewedMinutes', {required: false})}
                            id="viewedMinutes" name="viewedMinutes" label="Viewed Minutes"
                            aria-describedby="viewedMinutes_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.viewedMinutes)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('rating', {required: false})}
                            id="rating" name="rating" label="Rating" aria-describedby="rating_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.rating)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('source', {required: false})}
                            id="source" name="source" label="Source" aria-describedby="source_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.source)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status" aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.viewershipSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>

                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeViewershipDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>

            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorViewershipDrawerState}
                onClose={closeViewershipDrawer}
            >
                {viewershipForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
